import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_THIRD_PARTY_LIST = createRequestTypes('GET_THIRD_PARTY_LIST');
export const CREATE_ACCOUNT = createRequestTypes('CREATE_ACCOUNT');
export const EDIT_ACCOUNT = createRequestTypes('EDIT_ACCOUNT');
export const DISABLE_EDIT = createRequestTypes('DISABLE_EDIT');
export const VERIFY_THIRD_PARTY_ACCOUNT_OTP = createRequestTypes('VERIFY_THIRD_PARTY_ACCOUNT_OTP');
export const RESEND_THIRD_PARTY_ACCOUNT_OTP = createRequestTypes('RESEND_THIRD_PARTY_ACCOUNT_OTP');
export const CLEAR_THIRD_PARTY_ACCOUNT_OTP = 'CLEAR_THIRD_PARTY_ACCOUNT_OTP';
export const clearThirdPartyAccountOtp = () => createAction(CLEAR_THIRD_PARTY_ACCOUNT_OTP);

export const getThirdPartyList = {
  request: () => createAction(GET_THIRD_PARTY_LIST[REQUEST]),
  success: (response) => createAction(GET_THIRD_PARTY_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_THIRD_PARTY_LIST[FAILURE], { response }),
};

export const createAccount = {
  request: (payload) => createAction(CREATE_ACCOUNT[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(CREATE_ACCOUNT[SUCCESS], { response, requestPayload }),
  failure: (response) => createAction(CREATE_ACCOUNT[FAILURE], { response }),
};

export const editAccount = {
  request: (payload) => createAction(EDIT_ACCOUNT[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(EDIT_ACCOUNT[SUCCESS], { response, requestPayload }),
  failure: (response) => createAction(EDIT_ACCOUNT[FAILURE], { response }),
};

export const verifyThirdPartyAccountOtp = {
  request: (payload) => createAction(VERIFY_THIRD_PARTY_ACCOUNT_OTP[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(VERIFY_THIRD_PARTY_ACCOUNT_OTP[SUCCESS], { response, requestPayload }),
  failure: (response, requestPayload) => createAction(VERIFY_THIRD_PARTY_ACCOUNT_OTP[FAILURE], { response, requestPayload }),
};

export const resendThirdPartyAccountOtp = {
  request: (payload) => createAction(RESEND_THIRD_PARTY_ACCOUNT_OTP[REQUEST], { payload }),
  success: (response, requestPayload) => createAction(RESEND_THIRD_PARTY_ACCOUNT_OTP[SUCCESS], { response, requestPayload }),
  failure: (response, requestPayload) => createAction(RESEND_THIRD_PARTY_ACCOUNT_OTP[FAILURE], { response, requestPayload }),
};

export const disableEdit = {
  request: (payload) => createAction(DISABLE_EDIT[REQUEST], { payload }),
  success: (response) => createAction(DISABLE_EDIT[SUCCESS], { response }),
  failure: (response) => createAction(DISABLE_EDIT[FAILURE], { response }),
};
